import React from 'react';
import './ScoreBanner.scss';

interface ScoreBannerProps {
  score: number;
  isHighRisk: boolean; // kept for backward compatibility — banner derives its own level
}

type RiskLevel = 'low' | 'high';

function getRiskLevel(score: number): RiskLevel {
  return score >= 3 ? 'high' : 'low';
}

const LEVEL_TEXT: Record<RiskLevel, string> = {
  low: 'חשד נמוך לספסיס',
  high: 'חשד גבוה לספסיס',
};

const ScoreBanner: React.FC<ScoreBannerProps> = ({ score }) => {
  const level = getRiskLevel(score);

  return (
    <div
      className={`sepsis-banner sepsis-banner--${level}`}
      role="status"
      aria-live="polite"
      data-testid="sepsis-score-banner"
      data-level={level}
    >
      <span className="sepsis-banner__text">
        <bdi dir="ltr" data-testid="sepsis-score">{score} / 8</bdi> קריטריונים חיוביים — {LEVEL_TEXT[level]}
      </span>
    </div>
  );
};

export default ScoreBanner;
